import { PropsWithChildren, useEffect } from 'react';

import { useAuthStore } from '../stores/auth-store';

const OAuthProvider = ({ children }: PropsWithChildren) => {
    const { createOAuthToken } = useAuthStore();

    useEffect(() => {
        createOAuthToken([
            'read-banks',
            'read-payment-gateways',
            'read-payment-configs',
        ]);
    }, []);

    return <>{children}</>;
};

export default OAuthProvider;
